// cookie-settings.ts (refactored)
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  CookieConsentService,
  CookieConsent,
} from '../../services/cookie-consent.service';

interface AccordionItem {
  id: keyof CookieConsent;
  title: string;
  content: string;
  isExpanded: boolean;
  isRequired: boolean;
  isEnabled: boolean;
}

@Component({
  selector: 'app-cookie-settings',
  templateUrl: './cookie-settings.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cookie-settings.scss',
})
export class CookieSettings implements OnInit {
  @Input() isOpen: boolean = false;
  @Output() modalClose = new EventEmitter<CookieConsent | null>();

  private cookieConsentService = inject(CookieConsentService);

  accordionItems: AccordionItem[] = [
    {
      id: 'necessaryConsent',
      title: 'Necessary Cookies',
      content:
        "These cookies are necessary for the website to be able to function, hence cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services. This includes setting your privacy preferences, logging in or filling in forms. You can set up your browser to block or alert you about these cookies, however some parts of the website won't work as a result. These cookies don't store any personally identifiable information.",
      isExpanded: false,
      isRequired: true,
      isEnabled: true,
    },
    {
      id: 'analyticsConsent',
      title: 'Analytics Cookies',
      content:
        'These cookies allow us to count visits and traffic sources so that we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you have visited our site.',
      isExpanded: false,
      isRequired: false,
      isEnabled: false,
    },
  ];

  ngOnInit(): void {
    // Load existing preferences if available
    const existingConsent = this.cookieConsentService.getConsent();

    if (existingConsent) {
      this.accordionItems.forEach((item) => {
        if (existingConsent[item.id] !== undefined) {
          item.isEnabled = existingConsent[item.id];
        }
      });
    }
  }

  toggleAccordion(item: AccordionItem): void {
    item.isExpanded = !item.isExpanded;
  }

  toggleSwitch(item: AccordionItem): void {
    if (!item.isRequired) {
      item.isEnabled = !item.isEnabled;
    }
  }

  saveCookiePreferences(): void {
    const preferences: CookieConsent = {
      necessaryConsent: true, // Always true
      analyticsConsent: false,
    };

    this.accordionItems.forEach((item) => {
      preferences[item.id] = item.isEnabled;
    });

    this.modalClose.emit(preferences);
  }

  closeDialog(): void {
    this.modalClose.emit(null);
  }
}
